import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaEdit, FaList, FaPen, FaPlus, FaSearch } from 'react-icons/fa';
import NavItem from '../../../components/NavItem';
import api from '../../../services/api';
import DataTable from 'react-data-table-component';
import ReactSelect from '../../../components/ReactSelect';
import IconButton from '../../../components/IconButton';
import { BsCardChecklist } from 'react-icons/bs';

export default function PainelChecklist() {
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem("empresa");
    const perfil = localStorage.getItem("perfil");
    const [filtro, setFiltro] = useState({ prazo: "2" });
    const [checklists, setChecklists] = useState([]);
    const [tableSelect, setTableSelect] = useState({});
    const [tableActions, setTableActions] = useState([]);
    const history = useHistory();
    const params = new URLSearchParams(window.location.search);

    const buscar = () => {
        setFiltro({
            ...filtro,
            ...{ buscando: true }
        });

        api({
            method: 'get',
            action: '/eventoChecklist',
            token: token,
            params: {
                empresa: empresa,
                ...filtro,
            }
        })
            .then(response => {
                setChecklists(response.data.data);
                setFiltro({ ...filtro, ...{ buscando: false } });
            }).catch(err => {
                //console.log(err)
            });
    };

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    useEffect(() => { //onload
        var ids = tableSelect.selectedRows ? tableSelect.selectedRows.map((row) => {
            return row.id;
        }).join(",") : "";
        if (tableSelect.selectedCount > 0) {
            setTableActions([
                <IconButton
                    small={true}
                    to={"/alterarEventoChecklist/" + tableSelect.selectedRows[0].id}
                    icon={<FaPen size={20} />}
                    color="primary">Alterar</IconButton>
            ]);
        } else {
            setTableActions([]);
        }
    },
        // eslint-disable-next-line
        [tableSelect]);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <ul className="nav">
                    {['diretor', 'gerentefinanceiro', 'gerentebackoffice', 'backoffice', 'gerenteevento', 'evento'].includes(perfil) ?
                        <NavItem to={"/cadastroEventoChecklist/"} icon={<FaPlus size={20} />} color="primary">Novo Checklist</NavItem> :
                        null}
                    {['diretor'].includes(perfil) ?
                        <NavItem to="/eventoChecklistModelo" icon={<FaList size={20} />} color="outline-dark">Modelos de Checklist</NavItem> :
                        null}
                </ul>
                <div className="page-title">
                    <h3>Checklist</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={(e) => { buscar(); e.preventDefault(); }}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <div className="form-group">
                                                        <label>Evento</label>
                                                        <ReactSelect
                                                            value={{ value: filtro.evento, label: filtro.nomeEvento }}
                                                            onChange={(e) => {
                                                                setFiltro({ ...filtro, ...{ "evento": e.value, "nomeEvento": e.label } });
                                                            }}
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/evento',
                                                                    token: token,
                                                                    params: {
                                                                        nome: input,
                                                                        situacao: ["ativo", "fechado", "cancelado"]
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map((registro) => {
                                                                            var label = registro.nome;
                                                                            if (registro.identificacao) {
                                                                                label = registro.identificacao + " - " + label;
                                                                            }
                                                                            if (registro.cliente) {
                                                                                label = label + ' - ' + registro.cliente.nome;
                                                                            }
                                                                            label = registro.codigo + " - " + label;
                                                                            return { value: registro.id, label: label }
                                                                        });
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <button type="submit" className="btn btn-primary me-1 mb-1">
                                                        <FaSearch size={20} /> Buscar</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section">
                    <div className="row mb-4">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body px-0 pb-0">
                                    <div className="table-responsive">
                                        <DataTable
                                            progressPending={filtro.buscando ?? false}
                                            progressComponent={<div>Buscando...</div>}
                                            noContextMenu="true"
                                            actions={tableActions}
                                            selectableRows={true}
                                            selectableRowsHighlight="true"
                                            onSelectedRowsChange={({ allSelected, selectedCount, selectedRows }) => {
                                                setTableSelect({ allSelected, selectedCount, selectedRows });
                                            }}
                                            loadOptions
                                            noDataComponent="Nenhum registro"
                                            paginationComponentOptions={{ rowsPerPageText: 'Linhas', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }}
                                            pagination="true"
                                            className="table mb-0"
                                            columns={[
                                                {
                                                    name: 'Modelo',
                                                    selector: row => row.modelo?.nome ?? "",
                                                    sortable: true,
                                                    width: "200px",
                                                    cell: (row) => {
                                                        return row.modelo?.nome ?? "";
                                                    },
                                                },
                                                {
                                                    name: 'Evento',
                                                    selector: row => row.evento.nome ?? "",
                                                    sortable: true,
                                                    cell: (row) => {
                                                        if (row.evento.nome) {
                                                            if (row.evento.identificacao) {
                                                                return row.evento.codigo + ' - ' + row.evento.identificacao + ' - ' + row.evento.nome ?? "";
                                                            } else {
                                                                return row.evento.codigo + ' - ' + row.evento.nome ?? "";
                                                            }
                                                        } else {
                                                            return "";
                                                        }
                                                    },
                                                },
                                                {
                                                    name: 'Cliente',
                                                    selector: row => row.evento.cliente.nome ?? "",
                                                    sortable: true,
                                                    cell: (row) => {
                                                        if (row.evento.cliente.nome) {
                                                            if (row.evento.cliente.municipio) { //tem municipio
                                                                return row.evento.cliente.codigo + ' - ' + row.evento.cliente.nome + ' - ' + row.evento.cliente.municipio + ' - ' + row.evento.cliente.uf;
                                                            } else { //nao tem municipio
                                                                return row.evento.cliente.codigo + ' - ' + row.evento.cliente.nome;
                                                            }
                                                        } else {
                                                            return "";
                                                        }
                                                    },
                                                },
                                                {
                                                    name: 'Responsável',
                                                    selector: row => row.evento.responsavel?.nome ?? "",
                                                    sortable: true,
                                                    width: "200px",
                                                    cell: (row) => {
                                                        if (row.evento.responsavel?.nome) {
                                                            return row.evento.responsavel.codigo + ' - ' + row.evento.responsavel.nome;
                                                        } else {
                                                            return "";
                                                        }
                                                    },
                                                },
                                            ]}
                                            data={checklists}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
}
